export default __webpack_public_path__ + "static/media/UploadPhoto.77cb94ad.svg";